import { LIST_ALLOCATIONS_SUCCESS } from 'redux/allocations/constants';

import {
  GET_PRODUCT_SUCCESS,
  GET_RELATED_PRODUCTS_SUCCESS,
  PRODUCT_OBJECT_REQUESTING,
  PRODUCT_LIST_REQUESTING,
  LIST_PRODUCTS_SUCCESS,
  RELATED_PRODUCTS_REQUESTING,
  RESET_PRODUCT_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: [],
  relatedProducts: {},
  isListFetching: false,
  isObjectFetching: false,
  isRelatedFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_PRODUCT_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false,
        isRelatedFetching: false
      };
    }
    case PRODUCT_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case PRODUCT_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_PRODUCTS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.products.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });

      return {
        ...state,
        data,
        query,
        isListFetching: false
      };
    }
    case LIST_ALLOCATIONS_SUCCESS: {
      const data = { ...state.data };
      action.payload.forEach((allocation) => {
        allocation.products.forEach((p) => {
          if (p.product) {
            data[p.productId] = p.product;
          }
        });
      });

      return {
        ...state,
        data
      };
    }
    case GET_PRODUCT_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case RELATED_PRODUCTS_REQUESTING: {
      return {
        ...state,
        isRelatedFetching: true
      };
    }
    case GET_RELATED_PRODUCTS_SUCCESS: {
      const data = { ...state.data };
      const relatedProducts = { ...state.relatedProducts };

      // Store individual products in data (from the products array)
      action.payload.products?.forEach((product) => {
        data[product.id] = product;
      });

      // Store related products mapping by main product ID
      if (action.payload.mainProductId) {
        relatedProducts[action.payload.mainProductId] =
          action.payload.products || [];
      }

      return {
        ...state,
        data,
        relatedProducts,
        isRelatedFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getProductBySlug = (products, slug) => {
  if (!products.data) {
    return null;
  }
  const productIds = Object.keys(products.data);
  const productBySlugId = productIds.find(
    (id) => products.data[id].slug === slug
  );
  if (productBySlugId) {
    return products.data[productBySlugId];
  }
  return null;
};
